import { CDN_URL } from '@/config/index.js';

// 各礼物配置
export const giftConf = {
  yuanbao: `${CDN_URL}/freeKingdoms/g_yuanbao.png`,
  xinyun: `${CDN_URL}/freeKingdoms/g_xinyun.png`,
  shengxing: `${CDN_URL}/freeKingdoms/g_shengxing.png`,
  shengjie: `${CDN_URL}/freeKingdoms/g_shengjie.png`,
  dige: `${CDN_URL}/freeKingdoms/g_dige.png`,
  yutai: `${CDN_URL}/freeKingdoms/g_yutai.png`,
  zhenyang: `${CDN_URL}/freeKingdoms/g_zhenyang.png`,
  hongyan: `${CDN_URL}/freeKingdoms/g_hongyan.png`,
  dianfeng: `${CDN_URL}/freeKingdoms/g_dianfeng.png`,
  juexing: `${CDN_URL}/freeKingdoms/g_juexing.png`,
  fudai: `${CDN_URL}/freeKingdoms/g_fudai.png`,
};

// 各礼包
export const sortGift = [
  // 绑定账号礼包
  [
    { type: 'fudai', word: '元宝福袋*10' },
    { type: 'xinyun', word: '幸运币*5' },
    { type: 'shengxing', word: '升星丹*10' },
  ],
  // 签到第1天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*5' },
    { type: 'shengxing', word: '升星丹*10' },
  ],
  // 签到第2天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*15' },
    { type: 'shengjie', word: '升阶书*50' },
  ],
  // 签到第3天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*10' },
    { type: 'yutai', word: '育胎丸*1' },
  ],
  // 签到第4天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*5' },
    { type: 'dige', word: '地格之象*50' },
  ],
  // 签到第5天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*10' },
    { type: 'shengxing', word: '升星丹*10' },
    { type: 'zhenyang', word: '珍养露*1' },
  ],
  // 签到第6天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*5' },
    { type: 'dige', word: '地格之象*100' },
  ],
  // 签到第7天礼包
  [
    { type: 'yuanbao', word: '元宝*100' },
    { type: 'xinyun', word: '幸运币*15' },
    { type: 'shengjie', word: '升阶书*50' },
    { type: 'hongyan', word: '红颜令*1' },
  ],
];

export const scoreGift = {
  // 积分20礼包
  20: [{ type: 'xinyun', word: '幸运币*20' }],
  // 积分30礼包
  30: [{ type: 'yuanbao', word: '元宝*300' }],
  // 积分40礼包
  40: [{ type: 'dianfeng', word: '巅峰令*20' }],
  // 积分70礼包
  70: [{ type: 'juexing', word: '觉醒丹*20' }],
  // 积分120礼包
  120: [{ type: 'dige', word: '地格之象*500' }],
};
